import * as React from "react";
import { useCallback } from "react";
import UsersDomain from "domainActions/users/UsersDomain";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import PaginatedSelect from "../common/Select/PaginatedSelect";
const formatUsers = (users) => users.map((user) => ({ label: `${user.username} (${user.fullName})`, value: user.username }));
const UsersSelectField = ({ value, onChange }) => {
  const currentUser = useCurrentUser();
  const loadUsers = useCallback(
    (pagination) => {
      if (!isPermitted(currentUser.permissions, "users:list")) {
        return Promise.resolve({
          pagination,
          total: 0,
          list: []
        });
      }
      return UsersDomain.loadUsersPaginated(pagination).then((results) => ({
        total: results.pagination.total,
        list: formatUsers(results.list.toArray()),
        pagination
      }));
    },
    [currentUser.permissions]
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedSelect,
    {
      id: "user-select-list",
      value,
      placeholder: "Select user(s)...",
      onLoadOptions: loadUsers,
      multi: true,
      onChange
    }
  );
};
export default UsersSelectField;
